/**
 * La tablet entregada a la clienta para firmar (9.13). Se guarda en sessionStorage antes de ir a la firma del proveedor,
 * para que a la vuelta (o si la clienta recarga o va a otra dirección de la tablet) no se vea nada del panel: solo la
 * espera de la firma y el PIN de quien la entregó.
 */
export interface EntregaFirma {
    documentId: string;
    citaId: string;
    /** Nombre de pila de la clienta. */
    cliente: string;
    /** El miembro que la entregó: solo él vuelve con su PIN. */
    memberId: string;
}

const CLAVE = 'reservaria.tablet.firma';

export type AlmacenEntrega = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'> | null;

export function almacenEntrega(): AlmacenEntrega {
    try {
        return typeof window === 'undefined' ? null : window.sessionStorage;
    } catch {
        return null;
    }
}

export function leerEntrega(almacen: AlmacenEntrega): EntregaFirma | null {
    try {
        const v: unknown = JSON.parse(almacen?.getItem(CLAVE) ?? 'null');
        if (typeof v !== 'object' || v === null) {
            return null;
        }
        const o = v as Record<string, unknown>;
        return typeof o.documentId === 'string' && typeof o.citaId === 'string' && typeof o.cliente === 'string' && typeof o.memberId === 'string'
            ? { documentId: o.documentId, citaId: o.citaId, cliente: o.cliente, memberId: o.memberId }
            : null;
    } catch {
        return null;
    }
}

export function guardarEntrega(almacen: AlmacenEntrega, entrega: EntregaFirma | null): void {
    try {
        if (entrega === null) {
            almacen?.removeItem(CLAVE);
        } else {
            almacen?.setItem(CLAVE, JSON.stringify(entrega));
        }
    } catch {
        // Sin almacenamiento: vive solo en memoria.
    }
}

/** La dirección de vuelta del proveedor: la firma en el centro con `vuelta=1` (y lo que ya traía), solo si es https (G475). */
export function vueltaDeFirma(origen: string, ruta: string): string | null {
    try {
        const u = new URL(ruta, origen);
        if (u.protocol !== 'https:') {
            return null;
        }
        u.searchParams.set('vuelta', '1');
        return u.toString();
    } catch {
        return null;
    }
}
